import {
  Environment,
  InsightsRestrictions,
  PermissionStatus,
} from '@unu/ui-enums';

const tag = ({
  context,
  args,
}) => console.log(
  ...args, {
    context,
  },
);

const traceError = ({
  context,
  args,
}) => console.error(
  ...args, {
    context,
  },
);

const traceInformation = ({
  context,
  args,
}) => console.info(
  ...args, {
    context,
  },
);

const traceWarning = ({
  context,
  args,
}) => console.warn(
  ...args, {
    context,
  },
);

export const ConsoleInsightsInterface = {
  overrides: {
    permissionStatus: PermissionStatus.Approved,
  },
  restrictions: {
    [InsightsRestrictions.Environments]: [
      Environment.Local,
    ],
  },
  factory: () => ({
    tag,
    traceError,
    traceInformation,
    traceWarning,
  }),
}